import React from 'react';
import { Document, Page, Text, View, StyleSheet, Font } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 60,
    fontFamily: 'Helvetica',
    fontSize: 11,
    lineHeight: 1.5,
    color: '#333'
  },
  header: {
    marginBottom: 40,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    paddingBottom: 20
  },
  title: {
    fontSize: 24,
    fontFamily: 'Helvetica-Bold',
    marginBottom: 10,
    color: '#111'
  },
  date: {
    fontSize: 10,
    color: '#666',
    marginBottom: 20
  },
  content: {
    textAlign: 'justify',
    marginBottom: 20
  },
  footer: {
    marginTop: 40,
    fontSize: 12,
    fontFamily: 'Helvetica-Bold'
  }
});

interface CoverLetterData {
    resume_dataOrName?: any; // To get the name
    text: string;
}

export const CoverLetterDocument = ({ data }: { data: CoverLetterData }) => {
  // Extract content. It might come as a raw string or an object depending on how it's passed.
  // In api.tsx, we will ensure it's passed correctly.
  
  const textContent = typeof data === 'string' ? data : (data.text || "");
  const currentDate = new Date().toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
  });

  return (
    <Document>
      <Page size="LETTER" style={styles.page}>
        <View style={styles.header}>
            <Text style={styles.title}>Cover Letter</Text>
            <Text style={styles.date}>{currentDate}</Text>
        </View>

        <View style={styles.content}>
           {/* Handle newlines properly by splitting */}
           {textContent.split('\n').map((line, i) => (
             <Text key={i} style={{ marginBottom: 8 }}>
               {line}
             </Text>
           ))}
        </View>
      </Page>
    </Document>
  );
};
